const providers = {

  setTitle (to) {
    document.title = to.meta.title || 'my proof';
  },

};

export default providers;
